import { render, staticRenderFns } from "./PostGalleryView.vue?vue&type=template&id=03685767"
import script from "./PostGalleryView.vue?vue&type=script&lang=ts"
export * from "./PostGalleryView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports